import { gql } from "@apollo/client";
import { REPORT_FRAGMENT } from "./getArchivedReportsCall";
import { MutateReportResponse } from "./createReportCall";

export const MARK_REPORT_AS_DELETED = gql`
  mutation MarkReportAsDeleted($domain: String!, $ids: [Int!]!, $ifFetchData: Boolean!) {
    report {
      markAsDeleted(domain: $domain, ids: $ids) {
        message
        success
        code
        updatedValues {
          ...ReportFields
        }
      }
    }
  }
  ${REPORT_FRAGMENT}
`


export interface MarkReportAsDeletedResponse {
  report: {
    markAsDeleted: MutateReportResponse
  }
}